import { ActionValue, CacheDatasetType, DatasetInfoTab, DatasetType, SourceDatasetType } from "./types";

export const I2B2_PLUGIN = "i2b2_plugin";

export enum DatasetAttribute {
  PATIENT_COUNT = "patient_count",
  CREATED_DATE = "created_date",
  VERSION = "version",
  ENTITY_COUNT_DISTRIBUTION = "entity_count_distribution",
}

export enum VisibilityStatus {
  HIDDEN = "HIDDEN",
  PUBLIC = "PUBLIC",
  DEFAULT = "DEFAULT",
}

export enum ConfigTypes {
  OVERVIEW_DESCRIPTION = "overview-description",
  PRIVACY_POLICY = "privacy-policy",
  TERMS_OF_USE = "terms-of-use",
  IMPRINT = "imprint",
  PRIVACY_POLICY_DISPLAY = "privacy-policy-display",
  TERMS_OF_USE_DISPLAY = "terms-of-use-display",
  IMPRINT_DISPLAY = "imprint-display",
  HYBRID_SEARCH = "hybrid-search",
  DATAFLOW_GIT_CONFIG = "dataflow-git-config",
  NOTEBOOK_GIT_CONFIG = "notebook-git-config",
  DISCLAIMER = "disclaimer",
  DISCLAIMER_DISPLAY = "disclaimer-display",
  HEADER_IMAGE = "header-image",
  DATA_QUALITY_DESCRIPTION = "data-quality-description",
  DATA_QUALITY_DESCRIPTION_DISPLAY = "data-quality-description-display",
}

export const PUB_SLOT_NAME = "data2evidence";

export const DatasetMap: Record<SourceDatasetType, CacheDatasetType[]> = {
  [SourceDatasetType.SOURCE]: [
    CacheDatasetType.OMOP,
    CacheDatasetType.STUDY,
    CacheDatasetType.HANA__OMOP,
    CacheDatasetType.HANA__NON_OMOP,
  ],
  [SourceDatasetType.FHIR]: [CacheDatasetType.NON_OMOP],
  [SourceDatasetType.STRATEGUS_ANALYSIS]: [CacheDatasetType.NON_OMOP],
};

export const ResearcherFeatures = ["Notebooks", "Results", "Concepts", "Cohorts", "Analysis"];

export const ActionSelectorMap: Record<DatasetType, ActionValue[]> = {
  source: ["info", "metadata", "version", "delete", "transform-to-webapi"],
  fhir: ["info", "metadata", "delete"],
  non_omop: ["metadata", "permissions", "resources", "delete", "create-cache"],
  omop: [
    "metadata",
    "permissions",
    "resources",
    "delete",
    "data-quality",
    "data-characterization",
    "setup-semantic-search",
    "manage-dashboard",
    "create-cache",
  ],
  study: ["metadata", "permissions", "resources", "delete"],
  hana__omop: [
    "metadata",
    "permissions",
    "resources",
    "delete",
    "data-quality",
    "data-characterization",
    "setup-semantic-search",
    "manage-dashboard",
  ],
  hana__non_omop: ["metadata", "permissions", "resources", "delete", "manage-dashboard"],
  strategus_analysis: ["metadata", "permissions", "resources", "delete"],
  webapi: [
    "info",
    "metadata",
    "permissions",
    "resources",
    "delete",
    "data-quality",
    "data-characterization",
    "setup-semantic-search",
    "manage-dashboard",
    "refresh-cache",
  ],
  i2b2: ["metadata", "permissions", "resources", "delete"],
};

export const InformationPageMap: Record<DatasetType, DatasetInfoTab[]> = {
  source: [],
  fhir: [],
  non_omop: [DatasetInfoTab.DatasetInfo],
  omop: [DatasetInfoTab.DatasetInfo, DatasetInfoTab.DataQuality, DatasetInfoTab.DataCharacterization],
  study: [DatasetInfoTab.DatasetInfo],
  hana__omop: [DatasetInfoTab.DatasetInfo, DatasetInfoTab.DataQuality, DatasetInfoTab.DataCharacterization],
  hana__non_omop: [DatasetInfoTab.DatasetInfo, DatasetInfoTab.DataQuality, DatasetInfoTab.DataCharacterization],
  strategus_analysis: [DatasetInfoTab.DatasetInfo],
  webapi: [DatasetInfoTab.DatasetInfo, DatasetInfoTab.DataQuality, DatasetInfoTab.DataCharacterization],
  i2b2: [DatasetInfoTab.DatasetInfo],
};

export const ResearcherFeatureMap: Record<DatasetType, (typeof ResearcherFeatures)[number][]> = {
  source: [],
  fhir: [],
  non_omop: ["Cohorts", "Notebooks"],
  omop: ["Cohorts", "Notebooks", "Analysis", "Concepts"],
  study: ["Cohorts", "Notebooks", "Results"],
  hana__omop: ["Cohorts", "Notebooks", "Concepts"],
  hana__non_omop: ["Cohorts", "Notebooks"],
  strategus_analysis: [],
  webapi: ["Cohorts", "Notebooks", "Analysis", "Concepts"],
  i2b2: ["Cohorts", "Notebooks"],
};

export enum LogResponseType {
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
}
